import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {GlobalSearchResult} from "../global-search-result";
import {annotate} from "rough-notation";
import {GlobalSearchResultType} from "../../../enums/global-search-result-type";
import {ProfessionsService} from "../../../services/professions.service";
import {ProvidersService} from "../../../services/providers.service";
import {JobService} from "../../../services/job.service";
import {StoryService} from "../../../story/story.service";
import {ProviderTypes} from "../../../enums/provider-types";

@Component({
  selector: 'brt-global-search-overlay-result',
  templateUrl: './global-search-overlay-result.component.html',
  styleUrls: ['./global-search-overlay-result.component.scss']
})
export class GlobalSearchOverlayResultComponent implements AfterViewInit {

  @Input('data') set setData(val: GlobalSearchResult) {
    if(val) {
      this.resultData = val;
      this.setStringType();
      this.setLink();
    }
  }
  @ViewChild('contentEl') contentEl!: ElementRef<null>;

  resultData!: GlobalSearchResult;
  stringType = "";
  link = "";

  constructor(private professionsService: ProfessionsService,
              private providersService: ProvidersService,
              private jobService: JobService,
              private storyService: StoryService) {
  }
  ngAfterViewInit() {
    if(this.contentEl && this.contentEl.nativeElement) {
      const htmlEl = this.contentEl.nativeElement as HTMLElement;
      htmlEl.querySelectorAll("em").forEach((el) => {
        const newAnnotate = annotate(el, {
          type: "highlight",
          animationDuration: 1,
          iterations: 2,
          color: "#BACFD3",
          padding: 15,
          multiline: true
        });
        newAnnotate.show();
      })

    }
  }

  setStringType() {
    switch (this.resultData.type) {
      case GlobalSearchResultType.PROFESSION_APPRENTICESHIP:
        this.stringType = "Lehrberuf";
        break;
      case GlobalSearchResultType.PROFESSION:
        this.stringType = "Beruf";
        break;
      case GlobalSearchResultType.COMPANY:
        this.stringType = "Unternehmen";
        break;
      case GlobalSearchResultType.SCHOOL:
        this.stringType = "Weiterführende Schule";
        break;
      case GlobalSearchResultType.INSTITUTION:
        this.stringType = "BO-Einrichtung";
        break;
      case GlobalSearchResultType.DAILY_ROUTINE:
        this.stringType = "Tagesablauf";
        break;
      case GlobalSearchResultType.SCHOOL_PORTRAIT:
        this.stringType = "Schulportrait";
        break;
      case GlobalSearchResultType.VR_VIDEO:
        this.stringType = "VR Video";
        break;
      case GlobalSearchResultType.APPRENTICESHIP:
        this.stringType = "Lehrstelle";
        break;
      case GlobalSearchResultType.HOLIDAY_JOB:
        this.stringType = "Ferialjob";
        break;
      case GlobalSearchResultType.INTERNSHIP:
        this.stringType = "Praktikum";
        break;
    }
  }

  setLink() {
    const {type} = this.resultData;
    if(type === GlobalSearchResultType.PROFESSION || type === GlobalSearchResultType.PROFESSION_APPRENTICESHIP) {
      this.link = this.professionsService.getProfessionUrlById(parseInt(this.resultData.id));
    } else if(type === GlobalSearchResultType.COMPANY || type === GlobalSearchResultType.INSTITUTION || type === GlobalSearchResultType.SCHOOL) {
      let companyType = ProviderTypes.COMPANY;
      if(type === GlobalSearchResultType.SCHOOL) companyType = ProviderTypes.SCHOOL;
      else if(type === GlobalSearchResultType.INSTITUTION) companyType = ProviderTypes.BOINSTITUTION;
      this.link = this.providersService.getProviderDetailPageUrlById(this.resultData.id, companyType);
    } else if(type === GlobalSearchResultType.INTERNSHIP || type === GlobalSearchResultType.APPRENTICESHIP || type === GlobalSearchResultType.HOLIDAY_JOB) {
      this.link = this.jobService.getDetailPageUrlById(parseInt(this.resultData.id));
    } else if(type === GlobalSearchResultType.DAILY_ROUTINE || type === GlobalSearchResultType.VR_VIDEO || type === GlobalSearchResultType.SCHOOL_PORTRAIT) {
      this.link = '/' + this.storyService.STORIES_OVERVIEW_ENDPOINT + "#" + this.storyService.getStoryHashLink(parseInt(this.resultData.id), 0);
    }

    this.link = `${window.location.origin}${this.link}`;
  }

}
